import { useSupplyCatalog } from "@/components/supply/catalogData";
import { PackagePicker, ItemPicker } from "@/components/supply/SupplyPickers";
import { CustomizationFields, FulfillmentFields, EstimateBox } from "@/components/supply/SupplyOrderParts";

export const EMPTY_SUPPLY = {
  details: "", quantity: "", needed_by: "", fulfillment: "", pickup_location: "", delivery_address: "", shipping_address: "",
  package: "", package_addons: [], package_2xl: 0, event_address: "", items: [], customization: {}, files: [],
};

export const SupplyFields = ({ value, onChange, est, err, lead }) => {
  const cat = useSupplyCatalog();
  const set = (patch) => onChange({ ...value, ...patch });
  if (!cat) return <div className="mt-8 text-sm" data-testid="book-supply-fields">Loading catalog…</div>;
  const ctx = est?.context || { graduation: false, birthday: false };
  return (
    <div className="mt-8 p-5 border space-y-8" style={{ borderColor: "var(--ss-border)" }} data-testid="book-supply-fields">
      <div>
        <div className="font-label text-xs" style={{ color: "var(--ss-rust)" }}>The Social Supply · Order Request</div>
        <p className="mt-2 text-xs" style={{ color: "var(--ss-muted)" }}>Submitting this form is an order request — it is reviewed and approved before your agreement and payment. Social Supply orders are paid 100% at purchase. Payment does not start production; production begins only after you approve your final design proof.</p>
      </div>
      <PackagePicker cat={cat} value={value} set={set} />
      {value.package ? (
        <details data-testid="supply-more-products">
          <summary className="cursor-pointer font-label text-[0.65rem] py-2" style={{ color: "var(--ss-gold)" }} data-testid="supply-more-products-toggle">
            + Add more products (optional){value.items.length ? ` · ${value.items.length} added` : ""}
          </summary>
          <div className="mt-4"><ItemPicker cat={cat} value={value} set={set} /></div>
        </details>
      ) : <ItemPicker cat={cat} value={value} set={set} />}
      {!est?.executive_resource && (
        <label className="flex flex-col text-xs max-w-xs" style={{ color: "var(--ss-muted)" }}>Needed-by date
          <input type="date" className="editorial-input" data-testid="book-supply-needed-by" min={est?.earliest_date}
                 value={value.needed_by} onChange={(e) => set({ needed_by: e.target.value })} />
        </label>
      )}
      {est?.executive_resource ? (
        <div className="space-y-2" data-testid="supply-event-address">
          <div className="font-label text-[0.6rem]" style={{ color: "var(--ss-gold)" }}>Event address</div>
          <input required className="editorial-input" placeholder="Event address (street, city, state, ZIP)" data-testid="book-supply-event-address"
                 value={value.event_address} onChange={(e) => set({ event_address: e.target.value })} />
          <p className="text-xs" style={{ color: "var(--ss-muted)" }}>Your nightclub and included custom products are delivered and set up at your event. Standard nightclub travel and service-area terms apply.</p>
        </div>
      ) : <FulfillmentFields v={value} set={set} />}
      <CustomizationFields v={value} set={set} ctx={ctx} />
      <EstimateBox est={est} err={err} lead={lead} />
    </div>
  );
};
